import type { IconSvgObject } from './types';

const Flag02Icon: IconSvgObject = [
  ["path", { d: "M4 14L4 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.7576 3.83892C8.45236 2.12985 5.29699 3.39729 4 4.42024V14.8254C4.9697 13.7112 7.87879 11.9841 11.7576 13.9897C15.224 15.7821 18.6044 14.7976 20 14.0232V4.00813C17.3096 5.2316 14.4173 5.21419 11.7576 3.83892Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Flag02Icon;
